import { useSearchParams } from 'react-router-dom';

const spanKey = 'span';
const startDateKey = 'startDate';
const endDateKey = 'endDate';
export const useSaveOrigin = () => {
  const [searchParams] = useSearchParams();
  const span = searchParams.get(spanKey) || '';
  const startDate = searchParams.get(startDateKey) || '';
  const endDate = searchParams.get(endDateKey) || '';
  const linkParams = new URLSearchParams({
    from: 'allocations',
    span,
    startDate,
    endDate,
  });
  return `?${linkParams}`;
};
